import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useInitializeAuth from './hooks/useInitializeAuth'
import CantiquesList from './cantiques/CantiquesList' // cantiques list component
import CantiquesDetails from './cantiques/CantiquesDetails' // cantiques details component
import CantiquesEdit from './cantiques/CantiquesEdit' // cantiques edit component
import AdminDashboard from './Admin/AdminDashboard' // Admin dashboard component
import CantiquesListAdmin from './Admin/CantiqueListAdmin' // Admin cantiques list component
import CantiquesForm from './Admin/CantiqueForm' // Admin cantiques form component
import Header from './layouts/Header' // Header component
import Sidebard from './layouts/Sidebard' // Sidebard component
import Login from './auth/Login'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './layouts/Home'
 import HomeDisplayCantique from './layouts/HomeDisplayCantique'
import Display from './layouts/Display'
import AuthModal from './components/AuthModal'
import { useTheme } from './Context/ThemeContext'
import GeoConsent from './components/GeoConsent'
import useVisitorTracking from './hooks/useVisitorTracking'

const App = () => {
  // Initialiser l'authentification au démarrage
  useInitializeAuth();
  useVisitorTracking();
  const { theme } = useTheme();

  const location = useLocation();
  const hideSidebar = location.pathname === '/login';

  return (
    <div className="app">
         <div className="app__container">
              {!hideSidebar && (
                <div className="app__fonctions">
                  <Sidebard />
                </div>
              )}
              <div className={`app__content ${hideSidebar ? 'app__content--full' : ''}` }>
                 <Routes>
                    {/* the single `Display` route chooses between Home and selected cantique */}
                    <Route path="/" element={<Display />} />
                    <Route path="/home" element={<Display />} />
                    <Route path="/cantiques" element={<Display />} />
                    <Route path="/cantiques/:id" element={<Display />} />
                    <Route path="/cantiques-list" element={<CantiquesList />} />
                    <Route path='/admin' element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                    <Route path='/login' element={<Login />} />
                 </Routes>
              </div>
         </div>
         <ToastContainer theme={theme} />
         <AuthModal />
         <GeoConsent />
    </div>
  )
}

export default App